import { useMutation, useQuery } from "@tanstack/react-query";
import { httpClient, ROOT_URL } from "../App";
import { BaseKey } from "node_modules/@refinedev/core/dist";

export const useGetListRequestMoney = (params: {
  start: number;
  end: number;
  name?: string;
  status?: string;
  gte?: string;
  lte?: string;
  timeZone?: string;
}) => {
  return useQuery<any>(
    [
      `/api/v1/payment_orders/get-list`,
      params.start,
      params.end,
      params.name,
      params.status,
      params.gte,
      params.lte,
      params.timeZone,
    ],
    async () => getListRequestMoney(params)
  );
};

export function getListRequestMoney({
  start,
  end,
  name,
  status,
  gte,
  lte,
  timeZone,
}: {
  start: number;
  end: number;
  name?: string;
  status?: string;
  gte?: string;
  lte?: string;
  timeZone?: string;
}) {
  const params = new URLSearchParams();
  params.append("_start", String(start));
  params.append("_end", String(end));
  if (name) params.append("_like", name);
  if (status) params.append("_status", status);
  if (gte) params.append("_gte", gte);
  if (lte) params.append("_lte", lte);
  if (timeZone) params.append("_timeZone", timeZone);
  window.dispatchEvent(new CustomEvent('updateUnreadCounts'))
  return httpClient.get(
    `${ROOT_URL}/api/v1/payment_orders/get-list?${params.toString()}`
  );
}

export const useChangeStatusPaymentRequest = (config = {}) => {
  return useMutation({
    ...config,
    mutationFn: changeStatusPaymentRequest,
  });
};

export function changeStatusPaymentRequest(params: any) {
  const { id, ...bodyUpdate } = params;
  const body = { ...bodyUpdate };
  return httpClient.patch(`${ROOT_URL}/api/v1/payment_orders/${id}`, body);
}

export const useChangeStatusInvoicePayple = (config = {}) => {
  return useMutation({
    ...config,
    mutationFn: changeStatusInvoicePayple,
  });
};

export function changeStatusInvoicePayple(params: {
  id: BaseKey;
  status: string;
}) {
  const body = {
    status: params.status,
    id: params.id,
  };
  return httpClient.patch(`${ROOT_URL}/api/v1/invoice_payables/update`, body);
}
